import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const { login, handleCallback, isAuthenticated } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const callbackProcessed = useRef(false);

  const redirectAfterLogin = () => {
    const target = sessionStorage.getItem('postLoginRedirect');
    sessionStorage.removeItem('postLoginRedirect');
    navigate(target && target !== '/login' ? target : '/');
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (code && !callbackProcessed.current) {
      callbackProcessed.current = true;
      setLoading(true);
      handleCallback(code)
        .then(() => {
          redirectAfterLogin();
        })
        .catch((err) => {
          setError('Authentication failed. Please try again.');
          setLoading(false);
          callbackProcessed.current = false;
        });
    } else if (!code && isAuthenticated) {
      redirectAfterLogin();
    }
  }, [location, handleCallback, navigate, isAuthenticated]);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError('');
      await login();
    } catch (err) {
      setError('Failed to initiate login. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>RSC Sales & Recruiting Toolbox</h1>
        <p className="login-subtitle">Sign in with your Microsoft 365 account</p>
        
        {error && <div className="error">{error}</div>}
        
        {loading ? (
          <div className="loading">Authenticating...</div>
        ) : (
          <button onClick={handleLogin} className="btn btn-primary btn-large">
            Sign in with Microsoft
          </button>
        )}
        
        
      </div>
    </div>
  );
};

export default Login;
